export const passwordMatches = value =>
  value.search(/[A-Z]/) === -1 || value.search(/[a-z]/) === -1 || value.search(/[0-9]/) === -1
